<style>
    .v-settings-menu .v-settings-menu-item {
        cursor: pointer;
    }

    .v-settings-menu .v-settings-menu-item:hover {
    }
</style>
<template>
    <div class="animated fadeIn v-reports-menu">
        <h5>{{Core.Definition.getDefinition('Rapports')}}</h5>
        <hr/>

        <b-row>
            <b-col v-if="Core.Session.AuthUser.can('report_commerce')" @click="$router.push(Core.Definition.getDefinition('/outils/rapports/commerce'))" lg="3" md="4">
                <div class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-shopping-cart font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Commerce')}}</h5>
                        <small>{{Core.Definition.getDefinition('Paiements, commandes, abonnements ...')}}</small>
                    </div>
                </div>
            </b-col>
            <b-col v-if="Core.Session.AuthUser.can('report_event')" @click="$router.push(Core.Definition.getDefinition('/outils/rapports/evenement'))" lg="3" md="4">
                <div class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-calendar font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Événement')}}</h5>
                        <small>{{Core.Definition.getDefinition('Réservations, visites, popularité ...')}}</small>
                    </div>
                </div>
            </b-col>
            <b-col v-if="Core.Session.AuthUser.can('report_system')" @click="$router.push(Core.Definition.getDefinition('/outils/rapports/systeme'))" lg="3" md="4">
                <div class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-cogs font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Système')}}</h5>
                        <small>{{Core.Definition.getDefinition('Utilisateurs, actions ...')}}</small>
                    </div>
                </div>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    export default {
        name: 'Reports',
        components: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        methods: {

        }
    }
</script>
